import { MarkElementMask } from './MarkElementMask';
import { dom } from '@Engage.Core';
export class TrimByHeight extends MarkElementMask {
    trim(element) {
        this.removeMarkClass(element);
        let containerHeight = this.maskingOptions.ContainerHeight;
        this.element = element;
        let excludeHeight = this.calculateExcludesHeight(element);
        this.markExcluded(element);
        dom.css(element, {
            'overflow': 'hidden',
            'whitespace': 'no-wrap',
            'height': (containerHeight + excludeHeight) + 'px'
        });
        this.markElement(element);
        this.markVisibleElements(element, dom.bottom(element));
        const markElements = this.getMarkElements(element);
        this.lastTrimElement = this.getLastMarkElement(element) || (markElements.length ? markElements[markElements.length - 1] : null) || element;
        this.wrapNextTextNodes(this.lastTrimElement, element);
        let accurateElement;
        if (dom.hasClass(this.lastTrimElement, 'Mg2-fade')) {
            accurateElement = this.lastTrimElement;
        }
        else {
            accurateElement = this.trimByHeightNode(this.lastTrimElement, dom.height(element));
        }
        this.removeNotMarked(element);
        this.addTerminator(accurateElement);
        this.removeHeightFromContent();
    }
    fade(element) {
        this.removeMarkClass(element);
        this.markExcluded(element);
        const result = this.splitElementFade(element);
        this.removeNotMarkedFade(result.updatedElement);
    }
    getLastTrimElement() {
        return this.lastTrimElement;
    }
    markVisibleElements(element, bottom) {
        let children = element.children;
        let childrenLength = children.length;
        if (childrenLength > 0) {
            for (let i = 0; i < childrenLength; i++) {
                if (this.elementInView(children[i], bottom) && !this.isExcludeElement(children[i])) {
                    this.markElement(children[i]);
                }
                this.markVisibleElements(children[i], bottom);
            }
        }
    }
    elementInView(el, bottom) {
        let elemTop = dom.top(el);
        let elemBottom = dom.bottom(el);
        let isVisible = elemTop <= bottom && elemBottom >= 0;
        return isVisible;
    }
    markElementWithChildren(element, children) {
        this.markElement(element);
        this.markChildren(children);
    }
    trimByHeightNode(element, sumHeight) {
        if (element && element.nodeName === 'IMG') {
            this.trimByHeightImgNode(element, sumHeight);
            return element;
        }
        return this.getAccurateHeight(element, sumHeight);
    }
    // public removeHeightFromContent(element: HTMLElement) {
    //     dom.css(element, {
    //         'overflow': 'hidden',
    //         'height': '100%'
    //     });
    // }
    getAccurateHeight(element, sumHeight) {
        const needBottom = this.maskingOptions.ContainerHeight - sumHeight;
        let elementText = element.innerText || element.textContent;
        if (!elementText) {
            this.elementNotResizeByText(element, needBottom);
            return element;
        }
        let wordArray = elementText.split(' ');
        let copyElement = element.cloneNode(true);
        while (dom.bottom(element) >= needBottom) {
            let word = wordArray.pop();
            if (word === undefined) {
                break;
            }
            element.innerText = wordArray.join(' ');
        }
        if (!wordArray) {
            this.elementNotResizeByText(copyElement, needBottom);
        }
        return element;
    }
    elementNotResizeByText(element, height) {
        dom.css(element, {
            'height': height + 'px'
        });
    }
    addTerminator(lastElement) {
        if (lastElement && lastElement.nodeName === 'IMG') {
            dom.after(lastElement, "<p>" + this.maskingOptions.Terminator + "</p");
            return;
        }
        if (lastElement) {
            lastElement.innerText = lastElement.innerText + this.maskingOptions.Terminator;
        }
    }
    trimByHeightImgNode(element, sumHeight) {
        dom.css(element, {
            'overflow': 'hidden',
            'whitespace': 'no-wrap',
            'height': (this.maskingOptions.ContainerHeight - sumHeight) + 'px'
        });
    }
    unMask() {
        super.unMask();
        this.removeHeightFromContent();
    }
}
